/**
 * メンテナンスモードかどうかを返す
 * 実際の運用では、PRでこの値をtrueに変更してメンテナンス画面を表示し、
 * リバートすることで通常画面に戻す
 * @returns メンテナンス中の場合はtrue
 */
export const isInMaintenanceMode = (): boolean => {
  return true
}
